<template>
    <div>
        <table class="table right-gram">
            <thead>
            <th :class="{'diff-thead': !showTd}">{{tableText?'城市':cityText? '省外城市':'省份'}}</th>
            <th>销量占比</th>
            <th v-if="showTd">省内分布</th>
            </thead>
        </table>
        <div :class="[changeClass? 'auto-height':'fixed-height']">
            <table class="table right-gram">
                <tbody>
                <tr v-for="(item,index) in dataList">
                    <td :class="{'diff-thead': !showTd}"><span class="icon-box"
                                                               :class="{'td1': showTd&&index===0,'td2': showTd&&index===1,'td3': showTd&&index===2,'td4': showTd&&index===3,'td5': showTd&&index===4, 'td-one':!showTd&&index===0,'td-two':!showTd&&index===1,'td-three':!showTd&&index===2}">{{index+1}}</span>{{item.name}}
                    </td>
                    <td id="bar" :class="{'diff-width': !showTd}"><span class="limit-width">{{item.ratio|toFixedPercent}}</span><span
                        class="bule-bar"
                        :style="{'background-image': backgroundImage, 'margin-left': marginLeft,height:'22px','margin-bottom': marginBottom,'border-right':'solid 1px #2a99f1',display:display,width: barWidth[index]}"></span>
                    </td>
                    <td v-if="showTd" @click="showDataTable(item)"><a href="javascript:void(0);">查看<span
                        class="iconfont">&#xe6a7;</span></a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<style rel="stylesheet/css" lang="postcss" scoped>
    @font-face {
        font-family: "iconfont"; /* project id 458209 */
        src: url("//at.alicdn.com/t/font_458209_53vlzjyc57phkt9.eot");
        src: url("//at.alicdn.com/t/font_458209_53vlzjyc57phkt9.eot?#iefix") format("embedded-opentype"),
        url("//at.alicdn.com/t/font_458209_53vlzjyc57phkt9.woff") format("woff"),
        url("//at.alicdn.com/t/font_458209_53vlzjyc57phkt9.ttf") format("truetype"),
        url("//at.alicdn.com/t/font_458209_53vlzjyc57phkt9.svg#iconfont") format("svg");
    }

    .iconfont {
        font-family: "iconfont";
    }

    .auto-height {
        height: 300px;
        overflow: auto;
    }

    .fixed-height {
        height: 400px;
        overflow: auto;
    }

    .right-gram {
        width: 100%;
        color: #152c3c;
        border: none;

    thead th {
        height: 40px;
        background-color: #f7f9fa;
        font-size: 14px;
        font-weight: 500;
        text-align: left;
        color: #142c3d;
    }

    thead th:first-child {
        padding-left: 46px;
        width: 19%;
    }

    thead th.diff-thead {
        width: 21%;
        padding: 20px;
    }

    tbody tr td.diff-thead {
        width: 22% !important;
    }

    tbody tr td:first-child {
        width: 19%;
    }

    thead th:nth-child(2), tbody tr td:nth-child(2) {
        width: 71%;
    }

    tbody tr td.diff-width {
        width: 77%;
    }

    thead th:nth-child(3), tbody tr td:nth-child(3) {
        width: 10%;
    }

    thead th:nth-child(n+2) {
        padding-left: 0px;
    }

    tbody {

    tr {
        text-align: left;
        height: 40px !important;
        box-shadow: inset 0 -0.5px 0 0 #e9eef0;

    td {
        height: 40px;
        line-height: 40px;
        padding: 0px;
        text-align: left;
        border: none;
        vertical-align: middle;

    .limit-width {
        width: 45px;
        display: inline-block;
    }

    .bule-bar {
        width: 0px;
        transition: all 1s linear;
        height: 30px;
    }

    .td1 {
        background-color: #ff2f40;
    }

    .td2 {
        background-color: #ffbc37;
    }

    .td3 {
        background-color: #139bfd;
    }

    .td4 {
        background-color: #1dd978;
        color: #ffffff !important;
    }

    .td5 {
        background-color: #4d7bf3;
        color: #ffffff !important;
    }

    .td-one {
        background-color: #ffb700;
    }

    .td-two {
        background-color: #a7bdcb;
    }

    .td-three {
        background-color: #c68372;
    }

    &
    :last-child a {
        color: #34aaff;
        margin-left: 20px;
        cursor: pointer;
    }

    }
    &
    :nth-child(n + 4) .icon-box {
        color: #152c3c;
        border: solid 0.5px #c6cacf;
    }

    }
    .icon-box {
        width: 18px;
        height: 18px;
        line-height: 18px;
        background-color: #ffffff;
        display: inline-block;
        text-align: center;
        color: #ffffff;
        border-radius: 2px;
        margin-right: 10px;
        margin-left: 20px;
    }

    }
    }
</style>
<script>
    import toFixedPercent from 'filters/toFixedPercent.js';
    export default {
        props: {
            dataList: {
                type: Array,
                required: true
            },
            showTd: {
                type: Boolean,
                required: false
            },
            tableText: {
                type: Boolean,
                required: false
            },
            changeClass: {
                type: Boolean,
                required: false
            },
            cityText: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                backgroundImage: "linear-gradient(93deg, #26abff, #0b93ff)",
                height: "22px",
                marginLeft: "10px",
                marginBottom: "-6px",
                display: "inline-block",
                ratio: 0,
                index: 0,
                barWidth: []
            };
        },
        methods: {
            computedWidth(ratio, index) {
                let percent = 0;
                ratio = parseFloat(ratio);
                if (index === 0) {
                    percent = "82%";
                    this.base = ratio / 0.82;
                } else {
                    percent = ratio / this.base * 100 + "%";
                }
                return percent;
            },
            showDataTable(name) {
                this.$emit("tableModal", name);
            }
        },
        watch: {
            dataList: function (value) {
                if (Array.isArray(value)) {
                    this.barWidth.length = 0;
                    value.forEach((i, index) => {
                        this.barWidth.push(this.computedWidth(i.ratio, index));
                    });
                }
            }
        },
        mounted() {
            this.$nextTick(function () {
                this.dataList.forEach((i, index) => {
                    this.barWidth.push(this.computedWidth(i.ratio, index));
                });
            });
        }
    };
</script>




// WEBPACK FOOTER //
// table.vue?7b29d5e3